import { Colors } from '@constants/colors.constants';
import { ArrowRight } from '@icons/index';
import { IconButton, Stack, styled, Typography } from '@mui/material';
import { AuditOfferFollowUp } from '@store/audits/audit-offer-followUp/audit-offer-followUp.model';
import { AuditProposalSuppliers } from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.model';
import { useTranslation } from 'react-i18next';
import OfferTagItem, { OfferStatusEnum } from './OfferTagItem';


// Item Fake Model
export interface OfferModel {
  id: number;
  offer: number;
  partners?: string[];
  emissionDate: Date;
  tag?: OfferStatusEnum;
}

const OfferItemStyled = styled(Stack)({
  borderRadius: '4px',

  backgroundColor: Colors.background,
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '29px 20px',
});

type ItemProps = Partial<AuditOfferFollowUp & AuditProposalSuppliers>

interface OfferItemProps {
  handleClick: () => void;
  item: ItemProps;
  isExpired?: boolean;
}

const OfferItem = (props: OfferItemProps) => {
  const { item, handleClick, isExpired } = props;
  const { t } = useTranslation();

  const partnerString = item.supplierUnit?.name || '';
  const partnerNameArray = item.supplierUnits?.map((item) => item.name) || [];
  const partnersString = partnerNameArray.join(', ');

  const StatusView = item.validatedAt ? <OfferTagItem tagStatus={OfferStatusEnum.VALIDATE} /> :
    item.answeredAt ? <OfferTagItem tagStatus={OfferStatusEnum.ANSWERED} /> :
      item.sentAt ? <OfferTagItem tagStatus={OfferStatusEnum.WAITING} /> : null;

  return (
    <OfferItemStyled direction={'row'}>
      <Stack flex={1}>
        <Typography color={Colors.black} fontWeight={700} fontSize='14px'>
          {item.name}
        </Typography>
      </Stack>
      <Stack width='50%' overflow='hidden'>
        <Typography color={Colors.black} width={'25rem'} textOverflow='ellipsis' noWrap fontWeight={400} fontSize='14px'>
          {partnerString || partnersString}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={3} flex={1} justifyContent='end' alignItems="center">
        <Stack spacing={1} alignItems="end">
          {!isExpired ? StatusView : null}
          <Typography color={Colors.black} fontWeight={400} fontSize='12px'>
            {t('audits.auditOfferFollowUp.allOffers.emissionDate', { value: new Date(item.createdAt as string) })}
          </Typography>
        </Stack>
        <IconButton onClick={handleClick}>
          <ArrowRight style={{ height: 17, width: 10 }} />
        </IconButton>
      </Stack>
    </OfferItemStyled>
  );
};

export default OfferItem;